<div class="container">
  <button
    type="button"
    mat-icon-button
    class="close-button"
    aria-label="ダイアログを閉じる"
    (click)="this.close()"
  >
    <mat-icon>close</mat-icon>
  </button>
  <div class="header">
    <h1 class="title">統合エクスポート</h1>
  </div>
  <div class="file-information-details">
    <div class="detail">
      <label class="label" for="start-date">開始日：</label>
      <div class="input-with-error">
        <div class="value">
          <app-date-input
            class="date-input"
            [id]="'start-date'"
            [inputDate]="this.startDate"
          ></app-date-input>
        </div>
        @if (this.formGroup.hasError('dateRangeInvalid')) {
          <div class="input-error">
            開始日は終了日より前の日付を選択してください。
          </div>
        }
        @if (this.formGroup.hasError('dateRangeTooLong')) {
          <div class="input-error">
            期間は{{ this.maxDateRangeDays }}日以内で指定してください。
          </div>
        }
      </div>
    </div>
    <div class="detail">
      <label class="label" for="end-date">終了日：</label>
      <div class="value">
        <app-date-input
          class="date-input"
          [id]="'end-date'"
          [inputDate]="this.endDate"
        ></app-date-input>
      </div>
    </div>
    <div class="period-note">
      ※ エクスポートできる期間は最大{{ this.maxDateRangeDays }}日です。
    </div>
    <fieldset class="skill-maps-section">
      <legend class="skill-maps-legend">スキルマップ</legend>
      @if (this.loading) {
        <div class="skill-maps-loading">
          <mat-spinner diameter="24"></mat-spinner>
        </div>
      }
      @if (!this.loading) {
        @if (this.skillMaps.length === 0) {
          <div class="skill-maps-empty">スキルマップがありません</div>
        }
        @if (this.skillMaps.length > 0) {
          <div class="skill-maps-header">
            <mat-checkbox
              [checked]="this.isAllSelected"
              [indeterminate]="this.isIndeterminate"
              (change)="this.toggleSelectAll($event.checked)"
            >
              すべて選択
            </mat-checkbox>
          </div>
          <div class="skill-maps-list">
            @for (skillMap of this.skillMaps; track skillMap) {
              <div class="skill-map-item">
                <mat-checkbox
                  [checked]="this.selectedSkillMapIds.includes(skillMap.id)"
                  (change)="this.toggleSkillMap(skillMap.id)"
                >
                  {{ skillMap.name }}（KA×{{
                    this.getKeyActionCount(skillMap)
                  }}）
                </mat-checkbox>
              </div>
            }
          </div>
        }
      }
    </fieldset>
  </div>
  <div class="action-buttons">
    <button class="cancel" rectangle variant="secondary" (click)="this.close()">
      キャンセル
    </button>
    <button
      class="export-button"
      rectangle
      [disabled]="!this.isFormValid"
      (click)="submit()"
    >
      エクスポート
    </button>
  </div>
</div>
